<template>
  <v-list-tile style="cursor: pointer" @click="$emit('onClick')">
    <v-list-tile-content>
      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <em class="fas fa-chevron-right" />
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUpInput/WrapUpParent.vue